import React from 'react';
import BrandCover from './BrandCover';
import { courseCoverFor } from '../data/courseCovers';
import './CourseCover.css';

export default function CourseCover({ courseId, title, category, icon, decorative = false, compact = false, className = '' }) {
  const src = courseCoverFor(courseId);
  if (!src) {
    return <BrandCover title={title} category={category} icon={icon} decorative={decorative} compact={compact} className={className} />;
  }
  return (
    <img
      className={`course-cover-image ${className}`.trim()}
      src={src}
      alt={decorative ? '' : `${title} course cover`}
      aria-hidden={decorative ? 'true' : undefined}
      loading="lazy"
      decoding="async"
    />
  );
}
